import { render, staticRenderFns } from "./ABWrapper.vue?vue&type=template&id=f535d13e&"
import script from "./ABWrapper.vue?vue&type=script&lang=js&"
export * from "./ABWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ABWrapper.vue?vue&type=style&index=0&id=f535d13e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports